module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "tenancy-expiry-table",
      "title": "Tenancy Expiry",
      "icon": "fa fa-calendar-day",
      "url": "/tenancy/expiry",
      "fields": _vm.fields,
      "sort-field": "siteName",
      "search-placeholder": "Landowner, Site Name, Site Group...",
      "detail-component": "property-details"
    },
    scopedSlots: _vm._u([{
      key: "expiry-details",
      fn: function(props) {
        return [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatSiteStatus(props.rowData.status))
          }
        }), _vm._v(" - "), _c('span', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(props.rowData.landowner))]), _vm._v(" "), (props.rowData.countOwners > 1) ? _c('b', [_vm._v(" (#" + _vm._s(props.rowData.countOwners) + " owners)")]) : _vm._e(), _vm._v(" "), _c('b', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.siteName))]), _vm._v(" "), _c('small', {
          staticClass: "text-info"
        }, [_vm._v("(" + _vm._s(props.rowData.siteId) + ")")]), _vm._v(" "), _c('div', {
          staticClass: "pull-right"
        }, [_vm._v(_vm._s(_vm.formatDate(props.rowData.expiry)) + " | "), _c('span', {
          class: props.rowData.expiryDays <= 30 ? 'text-danger' : (props.rowData.expiryDays >= 31 && props.rowData.expiryDays <= 90 ? 'text-warning' : 'text-success')
        }, [_vm._v(_vm._s(_vm.formatFriendlyDate(props.rowData.expiry)))])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fab8a56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/property/ExpiryTable.vue
// module id = 1580
// module chunks = 0